/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NamespaceSearchFilter } from './namespaceSearchFilter';


export interface NamespaceSearchRequest { 
    /**
     * A wrapper for a list of namespace search filters. At most one search filter is supported
     */
    namespaceSearchFilters?: Array<NamespaceSearchFilter>;
}
